export const SET_TIMER_NEXT_AVAILABLE = 'timer/SET_TIMER_NEXT_AVAILABLE';
export const SET_TIMER_REMAINING = 'timer/SET_TIMER_REMAINING';
